
export default {
  name: 'AppRadioList',
  props: {
    items: { type: Array, required: true }
  }
};
